<template>
    <el-dialog class="middleDialog" :visible.sync="visible" :close-on-click-modal="false" top="auto" width="1400px">
        <div class="card">
            <div class="mediaContainer">
                <div class="mediaHeader">
                    <div class="title">媒体记录</div>
                    <div class="tabContainer">
                        <div :class="['tab', active == 0 ? 'active' : '']" @click="changeActive(0)">照片</div>
                        <div :class="['tab', active == 1 ? 'active' : '']" @click="changeActive(1)">视频</div>
                        <div :class="['tab', active == 2 ? 'active' : '']" @click="changeActive(2)">音频</div>
                    </div>
                </div>
                <div class="mediaContent">
                    <template v-if="active == 0">
                        <ul v-if="photoList.length > 0" class="photos" v-infinite-scroll="loadPhoto"
                            infinite-scroll-immediate="false" style="overflow:auto">
                            <li v-for="(item, index) in photoList" :key="index">
                                <ImagePreview class="photo-item" :src="item.urlThumbnail" :preview-src="item.url"
                                    :preview-src-list="showImgList(photoList)" :current-index="index">
                                </ImagePreview>
                            </li>
                        </ul>
                        <div class="w100 flex row center middle color-gray pd-y-10 fs-16"
                            v-if="photoPageParams.loading">
                            加载中...
                        </div>
                        <div class="w100 flex row center middle color-gray pd-y-10 fs-16"
                            v-if="photoPageParams.pageEnd">
                            ———— · 没有更多了 · ————
                        </div>
                    </template>
                    <template v-else-if="active == 1">
                        <ul v-if="videoList.length > 0" class="photos" v-infinite-scroll="loadVideo"
                            infinite-scroll-immediate="false" style="overflow:auto">
                            <li v-for="(item, index) in videoList" :key="index" class="h-240">
                                <VideoPreview class="video-item" :cover-src="item.urlPreview" :video-id="Number(item.id)" />
                            </li>
                        </ul>
                        <div class="w100 flex row center middle color-gray pd-y-10 fs-16"
                            v-if="videoPageParams.loading">
                            加载中...
                        </div>
                        <div class="w100 flex row center middle color-gray pd-y-10 fs-16"
                            v-if="videoPageParams.pageEnd">
                            ———— · 没有更多了 · ————
                        </div>
                    </template>
                    <template v-else-if="active == 2">
                        <ul v-if="audioList.length > 0" class="photos" v-infinite-scroll="loadAudio"
                            infinite-scroll-immediate="false" style="overflow:auto">
                            <li v-for="(item, index) in audioList" :key="index">
                                <audio class="audio-item" :src="item.urlMp3" controls></audio>
                            </li>
                        </ul>
                        <div class="w100 flex row center middle color-gray pd-y-10 fs-16"
                            v-if="audioPageParams.loading">
                            加载中...
                        </div>
                        <div class="w100 flex row center middle color-gray pd-y-10 fs-16"
                            v-if="audioPageParams.pageEnd">
                            ———— · 没有更多了 · ————
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import ImagePreview from '@/components/imagePreview.vue';
import VideoPreview from '@/components/videoPreview.vue';
import { getChatDialogMediaVideos, getChatDialogMediaAudios, getChatDialogMediaPhotos } from '@/api/talkytimes/personalData'

export default {
    props: {
        platformUserId: {
            type: [String, Number],
            default: ''
        }
    },

    components: {
        ImagePreview,
        VideoPreview
    },
    data() {
        return {
            userId: 0,
            active: 0,
            photoList: [],
            videoList: [],
            audioList: [],
            photoPageParams: {
                idLastMessage: 0,
                limit: 12,
                loading: false,
                pageEnd: false
            },
            videoPageParams: {
                idLastMessage: 0,
                limit: 12,
                loading: false,
                pageEnd: false
            },
            audioPageParams: {
                idLastMessage: 0,
                limit: 12,
                loading: false,
                pageEnd: false
            },
            visible: false
        };
    },
    methods: {
        resetParams() {
            this.active = 0;
            this.videoList = []
            this.audioList = []
            this.photoList = []
            this.videoPageParams = {
                idLastMessage: 0,
                limit: 12,
                loading: false,
                pageEnd: false
            }
            this.audioPageParams = {
                idLastMessage: 0,
                limit: 12,
                loading: false,
                pageEnd: false
            }
            this.photoPageParams = {
                idLastMessage: 0,
                limit: 12,
                loading: false,
                pageEnd: false
            }
        },
        showImgList(list) {
            return list.map(item => item.url);
        },
        init(userId) {
            this.visible = true;
            this.userId = userId
            // 初始化参数
            this.resetParams()
            console.log('MediaHistory组件 init - userId:', this.userId)

            this.getVideoList()
            this.getAudioList()
            this.getPhotoList()
        },
        loadPhoto() {
            if (!this.photoPageParams.pageEnd) {
                this.getPhotoList()
            }
        },
        loadVideo() {
            if (!this.videoPageParams.pageEnd) {
                this.getVideoList()
            }
        },
        loadAudio() {
            if (!this.audioPageParams.pageEnd) {
                this.getAudioList()
            }
        },
        getVideoList() {
            this.videoPageParams.loading = true
            getChatDialogMediaVideos({
                idRegularUser: this.userId,
                idLastMessage: this.videoPageParams.idLastMessage,
                limit: this.videoPageParams.limit
            }).then(res => {
                this.videoList = this.videoList.concat(res);
                if (res.length < this.videoPageParams.limit) {
                    this.videoPageParams.pageEnd = true
                } else {
                    this.videoPageParams.idLastMessage = res[res.length - 1].idMessage
                    this.videoPageParams.pageEnd = false
                }
            }).finally(() => {
                this.videoPageParams.loading = false
            })
        },
        getAudioList() {
            this.audioPageParams.loading = true
            getChatDialogMediaAudios({
                idRegularUser: this.userId,
                idLastMessage: this.audioPageParams.idLastMessage,
                limit: this.audioPageParams.limit
            }).then(res => {
                this.audioList = this.audioList.concat(res);
                if (res.length < this.audioPageParams.limit) {
                    this.audioPageParams.pageEnd = true
                } else {
                    this.audioPageParams.idLastMessage = res[res.length - 1].idMessage
                    this.audioPageParams.pageEnd = false
                }
            }).finally(() => {
                this.audioPageParams.loading = false
            })
        },
        getPhotoList() {
            this.photoPageParams.loading = true
            console.log('getPhotoList - userId:', this.userId)

            // 使用 getChatDialogMediaPhotos 接口获取聊天媒体照片
            console.log('使用 getChatDialogMediaPhotos 接口')
            getChatDialogMediaPhotos({
                idRegularUser: this.userId,
                idLastMessage: this.photoPageParams.idLastMessage,
                limit: this.photoPageParams.limit
            }).then(res => {
                this.photoList = this.photoList.concat(res);
                if (res.length < this.photoPageParams.limit) {
                    this.photoPageParams.pageEnd = true
                } else {
                    this.photoPageParams.idLastMessage = res[res.length - 1].idMessage
                    this.photoPageParams.pageEnd = false
                }
            }).finally(() => {
                this.photoPageParams.loading = false
            })
        },
        changeActive(value) {
            this.active = value
        },
        closeClick() {
            this.resetParams();
            this.visible = false;
        },
    },
    mounted() {
    },
}
</script>

<style lang='scss' scoped>
.card {
    height: 100%;
}

.mediaContainer {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 20px;
}

.mediaHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #EEEEEE;

    .title {
        font-weight: 600;
        font-size: 24px;
        color: #333333;
    }

    .tabContainer {
        display: flex;
        gap: 2px;

        .tab {
            width: 80px;
            height: 40px;
            font-weight: 400;
            font-size: 16px;
            line-height: 40px;
            color: #999999;
            text-align: center;
            background-color: #F7F9FA;
            border-radius: 8px;
            cursor: pointer;
            transition: all 0.3s ease;

            &:hover {
                background-color: #EEEEEE;
                color: #666666;
            }

            &.active {
                font-weight: 500;
                font-size: 18px;
                color: #333333;
                background-color: #EEEEEE;
                border-radius: 8px;
                box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.12);
            }
        }
    }
}

.mediaContent {
    flex: 1;
    overflow: hidden;

    .photos {
        display: grid;
        width: 100%;
        height: 100%;
        grid-template-columns: repeat(4, 1fr);
        // grid-template-rows: repeat(auto-fit, 200px);
        gap: 12px;
        overflow-y: auto;
        max-height: calc(100vh - 200px);
        box-sizing: border-box;
        padding: 0;
    }

    .photos>div {
        width: 100%;
    }

    .photos .preview-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 8px;
    }

    .photos .video-cover {
        width: 100%;
        height: 100%;
    }

    .photos .cover-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 8px;
    }

    .photos .video-cover {
        width: 100%;
        height: 100%;
        aspect-ratio: 16/9;
    }

    .photos audio {
        width: 100%;
        height: calc(50% + 27px);
        border-radius: 8px;
    }
}

.h-240 {
    height: 240px;
}

.w100 {
    width: 100%;
}

.flex {
    display: flex;
}

.row {
    flex-direction: row;
}

.center {
    justify-content: center;
    align-items: center;
}

.middle {
    align-items: center;
}

.color-gray {
    color: #999999;
}

.pd-y-10 {
    padding: 10px 0;
}

.photo-item {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    ::v-deep img {
        max-width: initial;
        height: 100%;
    }
}

.video-item {
    width: 100%;
    height: 100%;
    ::v-deep .videoPreview {
        max-width: initial;
        height: 100%;
    }
}

.audio-item {
    width: 100%;
    height: 100%;
    ::v-deep .audio-preview {
        max-width: initial;
        height: 100%;
    }
}
</style>